import {MEASUREMENT_METHOD_SUCCESS, MEASUREMENT_METHOD_ERROR} from '../actions/measurement_pile_method';

const initialState = {
    data: '',
    error: null
};

export default function reducer(state = initialState, action) {
    if (action.type === MEASUREMENT_METHOD_SUCCESS) {
        return Object.assign({}, state, {
            data: action.data,
            error: null
        });
    } else if (action.type === MEASUREMENT_METHOD_ERROR) {
        alert(action.error)
        return Object.assign({}, state, {
            error: action.error
        });
    }
    return state;
}